export default "__VITE_ASSET__DNcNovzE__"